import styled from "styled-components";

export const SectionFluid = styled.section`
  padding: 6rem 0;
  background-color: ${(props) => (props.even ? "#FBFBFB" : "#fff")};

  h2 {
    font-size: 2.4rem;
    font-weight: normal;
  }

  .title-cnt {
    display: flex;
    gap: 1rem;
    margin-bottom: 4rem;
  }

  span {
    align-self: center;
    width: 2.5rem;
    height: 7px;
    background: #b6fcbf;

    @media screen and (max-width: 520px) {
      display: none;
    }
  }
`;
